import React from 'react';
import GuestSelectedView from './views/GuestSelectedView';
import { useGuestSelected } from './hooks/GuestSelected.hook';
import { useSelector } from 'react-redux';

const GuestSelectedController = () => {
  const {
    loading,
    error,
    showForm,
    guests,
    selectedCount,
    addGuest,
    selectGuest,
    showGuestForm,
    hideGuestForm,
  } = useGuestSelected();

  const languageData = useSelector(state => state.lenguage?.lang);

  const handleAddGuest = values => {
    addGuest(values);
  };

  const handleSelectGuest = guest => {
    selectGuest(guest.id);
  };

  const handleAddNewGuest = () => {
    showGuestForm();
  };

  const handleBack = () => {
    if (showForm) {
      hideGuestForm();
    } else {
      window.history.back();
    }
  };

  return (
    <GuestSelectedView
      showForm={showForm}
      guests={guests}
      selectedCount={selectedCount}
      onSelectGuest={handleSelectGuest}
      onAddGuest={handleAddNewGuest}
      onBack={handleBack}
      onSubmitForm={handleAddGuest}
      loading={loading}
      error={error}
      languageData={languageData}
    />
  );
};

export default GuestSelectedController;
